import { NodeStyle } from "../Graph.model";

const selectedNodeStyle: Partial<NodeStyle> = {
  underlayColor: "#17457b",
  underlayOpacity: 0.4,
};

export default selectedNodeStyle;
